import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import client from "@culturehq/client";
import { Modal, SearchBar, Table, Warning } from "@culturehq/components";

import { useFieldsLabels } from "app/hooks";
import { t, Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import ChqModal from "components/common/ChqModal";
import EntityRow from "./invite/EntityRow";

const InviteEntityTable = ({ entities, event, onRefreshInvitations }) => (
  <Table>
    <thead>
      <tr>
        <th />
        <th>
          Name
        </th>
        <th>
          <div className="text-center">RSVP</div>
        </th>
      </tr>
    </thead>
    <tbody>
      {entities.map(entity => (
        <EntityRow
          key={`${entity.type}/${entity.id}`}
          entity={entity}
          event={event}
          onRefreshInvitations={onRefreshInvitations}
        />
      ))}
    </tbody>
  </Table>
);

class InviteModalContext extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: "",
      error: false,
      loading: false,
      startOpen: props.location.hash === "#invite",
      entities: []
    };
  }

  handleClose = () => {
    this.setState({ entities: [] });
  };

  handleSearch = async query => {
    const { event: { id: eventId } } = this.props;

    try {
      const { entities } = await client.eventAutocompleteInvites({ query, eventId });

      this.setState({ entities, loading: false });
    } catch (error) {
      this.setState({ error, loading: false });
    }
  };

  handleSearchChange = query => {
    this.setState(({ entities }) => ({
      query,
      error: false,
      loading: query.length > 0,
      entities: query.length > 0 ? entities : []
    }));
  };

  render() {
    const { children, event, labels, onRefreshInvitations } = this.props;
    const { entities, error, query, loading, startOpen } = this.state;

    return (
      <ChqModal startOpen={startOpen} trigger={children} onClose={this.handleClose}>
        <Modal.Heading>
          Invite Users
        </Modal.Heading>
        <Modal.Body>
          <SearchBar
            autoFocus
            onSearch={this.handleSearch}
            onSearchChange={this.handleSearchChange}
            placeholder={t(`Search Users, Locations, ${labels.departments.plural}, or Interests.`)}
          />
          {error && <ErrorMessage error={error} />}
          <InviteEntityTable
            entities={entities}
            event={event}
            onRefreshInvitations={onRefreshInvitations}
          />

          {entities.length < 1 && !loading && (
            <Warning>
              {
                query
                  ? (
                    <Trans>
                      No results to show. Use the above search bar to find and
                      invite users one by one or by a group.
                    </Trans>
                  )
                  : (
                    <Trans>
                      Use the above search bar to find and invite users one by one
                      or by a group.
                    </Trans>
                  )
              }
            </Warning>
          )}
        </Modal.Body>
      </ChqModal>
    );
  }
}

const InviteModal = props => {
  const labels = useFieldsLabels();

  return (
    <InviteModalContext
      labels={labels}
      {...props}
    />
  );
};

export default withRouter(InviteModal);
